import './CardButton.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AddIcon from '@mui/icons-material/AddSharp';
import Button from 'src/component/UI/Button';

// A full-width dashed "add slot": it lives in the content flow, directly where the thing it
// creates will appear, rather than in a button bar. Sitting with the cards it appends to — and
// outlined like an empty one — is what tells the user it belongs to the form and not to the
// form's navigation. Built on Button so focus, disabled, loading and icon handling are shared.
export default function CardButton (props) {
  const { children, className, onClick, disabled, icon, ariaLabel } = props;

  return (
    <Button
      className={classNames('card-button', className)}
      onClick={onClick}
      disabled={disabled}
      icon={icon}
      ariaLabel={ariaLabel}
    >
      {children}
    </Button>
  );
}

CardButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array
  ]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  // Defaults to a plus; pass another element (or null) where a different affordance reads better.
  icon: PropTypes.element,
  ariaLabel: PropTypes.string
};

CardButton.defaultProps = {
  className: '',
  onClick: null,
  disabled: false,
  icon: <AddIcon />,
  ariaLabel: ''
};
